import React from 'react'
import { sendEvent } from '@/lib/logger'

interface Props {
  children: React.ReactNode
}

interface State {
  hasError: boolean
}

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    sendEvent('react.error_boundary', error.message, 'CRITICAL', {
      errorName: error.name,
      stack: error.stack,
      metadata: { componentStack: info.componentStack ?? undefined },
    })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className='flex min-h-screen items-center justify-center p-8 text-center'>
          <div>
            <p className='text-lg font-semibold'>Something went wrong.</p>
            <p className='mt-2 text-sm text-muted-foreground'>Try refreshing the page.</p>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}
